import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/inloggen", { replace: true });
      return;
    }
    api.post("/auth/google-session", { session_id: sessionId })
      .then((d) => {
        setUser(d.data);
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/account", { replace: true });
      })
      .catch(() => {
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/inloggen", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 size={36} className="text-gold animate-spin" />
    </div>
  );
};

export default AuthCallback;
